import {createAction, props} from '@ngrx/store';

export const ConfigurationActionType = '[Configuration] Update';
export const updateConfiguration = createAction(ConfigurationActionType, props<{cancellationUrl: string}>());

export const ConfigurationActions = {
  updateConfiguration,
};
